import React from 'react';
import Card from '../Common/Card';
import Button from '../Common/Button';
import { useNavigate } from 'react-router-dom';
import { ExternalLink, User } from 'lucide-react';
import { formatStatus } from '../../utils/formatters';

const getTypeColor = (type) => {

  switch (type) {
    case 'buyer':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300';
    case 'seller':
      return 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300';
    case 'both':
      return 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300';
    case 'definite_sale':
      return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300';
    case 'definite_rental':
      return 'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-300';
    case 'option':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300';
    case 'potential':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
  }
}

const InterestedCustomers = ({ customers }) => {
  const navigate = useNavigate();

  if (!customers || customers.length === 0) {
    return (
      <Card title="İlgilenen Müşteriler">
        <p className="text-center text-gray-500 py-8">
          Henüz bu portföy ile ilgilenen müşteri yok
        </p>
      </Card>
    );
  }

  return (
    <Card title="İlgilenen Müşteriler">
      <div className="space-y-3">
        {customers.map((customer) => (
          <div
            key={customer.id}
            className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary-100 dark:bg-primary-900 rounded-full flex items-center justify-center">
                <User size={20} className="text-primary-600 dark:text-primary-400" />
              </div>
              <div>
                <h4
                  className="font-semibold text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer transition-colors"
                  onClick={() => navigate(`/customers/${customer.id}`)}
                >
                  {customer.name} {customer.surname}
                </h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">

                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getTypeColor(customer.customer_type)}`}>
                    {formatStatus(customer.customer_type)}
                  </span>


                  {customer.sales_representative && ` • Temsilci: ${customer.sales_representative.name}`}
                </p>
                {customer.pivot?.notes && (
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Not: {customer.pivot.notes}
                  </p>
                )}
              </div>
            </div>
            <Button
              size="sm"
              variant="secondary"
              onClick={() => navigate(`/customers/${customer.id}`)}
            >
              <ExternalLink size={16} />
              Detay
            </Button>
          </div>
        ))}
      </div>
    </Card >
  );
};

export default InterestedCustomers;
